import { render, staticRenderFns } from "./Lgx328518181243060224.vue?vue&type=template&id=3f9a1e65&scoped=true&"
import script from "./Lgx328518181243060224.vue?vue&type=script&lang=js&"
export * from "./Lgx328518181243060224.vue?vue&type=script&lang=js&"
import style0 from "./Lgx328518181243060224.vue?vue&type=style&index=0&id=3f9a1e65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9a1e65",
  null
  
)

export default component.exports